let userLoggedIn = $('#userId').val();
(function () {
//on load
    var tab = get("tab");
    if(tab === "collapseFoodPref"){
        setTimeout(function(){
            $('a[href="#collapseTwo"]').trigger('click');
            $('a[href="#collapseHowYouLikeEat"]').trigger('click');
            $('a[href="#collapseHeadingYourPreferences"]').trigger('click');
            $('html, body').animate({
                scrollTop : $('a[href="#collapseTwo"]').offset().top},'slow');
            let baseurl = "users/healthy-eating-profile"
            let searchParams = new URLSearchParams(window.location.search);
            if(searchParams.has('next')) {
                const redirectto = searchParams.get('next');
                const buymenuitemid = searchParams.get('buymenuitemid');
                baseurl += `?next=${redirectto}&buymenuitemid=${buymenuitemid}`;
            } 
            window.history.replaceState({}, document.title, "/" + baseurl);
        }, 1000);
    } else if(tab === "collapseTasterProfile"){
         setTimeout(function(){
            $('a[href="#collapseTa"]').trigger('click');
            $('a[href="#collapseHowYouLikeEat"]').trigger('click');
            $('a[href="#collapseHeadingYourPreferences"]').trigger('click');
            $('html, body').animate({
                scrollTop : $('a[href="#collapseTa"]').offset().top},'slow');
            let baseurl = "users/healthy-eating-profile"
            let searchParams = new URLSearchParams(window.location.search);
            if(searchParams.has('next')) {
                const redirectto = searchParams.get('next');
                const buymenuitemid = searchParams.get('buymenuitemid');
                baseurl += `?next=${redirectto}&buymenuitemid=${buymenuitemid}`;
            } 
            window.history.replaceState({}, document.title, "/" + baseurl);
        }, 1000);
    }
    else if(tab === "collapseTasterPhone"){
        setTimeout(function(){
            $('a[href="#collapseZero"]').trigger('click');
            $('a[href="#collapsePersonalInfo"]').trigger('click');
            $('a[href="#collapseZero"]').trigger('click');
            $('html, body').animate({
            scrollTop : $('a[href="#collapseZero"]').offset().top},'slow');
            //window.history.replaceState({}, document.title, "/" + "users/healthy-eating-profile");
        }, 1000);
    }
    else if(tab === "collapsedeleteaccount"){
        setTimeout(function(){
            // $('a[href="#headingProfileSettings"]').trigger('click');
            $('a[href="#collapseProfileSettings"]').trigger('click');
            $('a[href="#collapseAccountSettings"]').trigger('click');
           
            $('html, body').animate({
            scrollTop : $('a[href="#collapseAccountSettings"]').offset().top},'slow');
            //window.history.replaceState({}, document.title, "/" + "users/healthy-eating-profile");
        }, 1000);
    }
    else if(tab === "collapsedeletedata"){
        setTimeout(function(){
            $('a[href="#collapseProfileSettings"]').trigger('click');
            $('a[href="#collapsePDU"]').trigger('click');
           // $('a[href="#collapseZero"]').trigger('click');
            $('html, body').animate({
            scrollTop : $('a[href="#collapsePDU"]').offset().top},'slow');
            //window.history.replaceState({}, document.title, "/" + "users/healthy-eating-profile");
        }, 1000);
    }
        if( $('li.menuitem a').hasClass('active') ){
            var activeItem = $("li a.active")
            if(activeItem[0].innerText=='Menu Items'){
                $(".search_filter_rating").css("display","block")
                $(".filter_locals_rating").css("display","block")
            }else{
                $(".search_filter_rating").css("display","none")
                $(".filter_locals_rating").css("display","none")
                    
            }
        }
	function get(name){
      if(name=(new RegExp('[?&]'+encodeURIComponent(name)+'=([^&]*)')).exec(location.search))
       return decodeURIComponent(name[1]);
    }
	
	/* why are we calling these here
  if( (typeof(primaryType) !== 'undefined') && primaryType=="menuitem"){
      searchResults('menuitem',1);
   } else if( (typeof(primaryType) !== 'undefined') && primaryType=="restaurant"){
      searchResults('restaurant',1);
  }
  */
    const $RADIUS_INPUT = $('.search-radius-input');
    const $RADIUS_VALUE = $('#radius');
    const $RADIUS_VALUE_TEXT = $('.radius-value-text');
    const $RADIUS_PRIVATE_VALUE = $('#radius_private_room');

    $RADIUS_INPUT.on('input', function() {
        //$RADIUS_INPUT.attr('max', 100);
        let radius = Number($(this).val()||0);
        $RADIUS_INPUT.val($(this).val());
        $RADIUS_VALUE_TEXT.text(radius);
        $RADIUS_VALUE.val(radius);
        $RADIUS_PRIVATE_VALUE.val(radius);
        });

    mapfunctionalityCheck();
})();


$(document).ready(function() {
  //for displaying tooltip of menuItem Description
  $('[data-toggle="tooltip"]').tooltip({
      trigger : 'hover'
  });
  /*if ($('.search-my-restaurant').length){
     $('html, body').animate({
       scrollTop: $('#search_results_div').offset().top - 30
     }, 'slow');
  }*/
    /* Show Item description remaining text */
    $('.btn-read-more').click(function(e) {
        e.preventDefault();
        $(this).parent().parent().find('.item-desc-more').show();
        $(this).parent().parent().find('.item-desc-less').hide();
        $(this).hide()
        $(this).parent().find('.btn-read-less').show()
    })

    $('.btn-read-less').click(function (e) {
        e.preventDefault();
        $(this).parent().parent().find('.item-desc-more').hide();
        $(this).parent().parent().find('.item-desc-less').show();
        $(this).hide();
        $(this).parent().find('.btn-read-more').show()
    })
    /* Get venue information for each search result */
    $('.results-content').each(function(index, element) {
        var parentContainer = ".results-container" + index;
        //var userAddress = $(this).find('#user-address').val().trim();
        var venueDistance = $(this).find('#venue-distance').val();
        var venueId = $(this).find('#venue-id').val().trim();
        var venueParams = {
            name: $(this).find('#venue-name').text().trim(),
            location: $(this).find('#venue-location').val().trim(),
            lat: $(this).find('#venue-lat').val().trim(),
            lng: $(this).find('#venue-lng').val().trim(),
            phone: $(this).find('#venue-phone').val().trim(),
            rating: $(this).find('#venue-rating').val().trim(),
            userRatingsTotal: $(this).find('#venue-user-ratings-total').val().trim(),
            ratingUpdatedOn: $(this).find('#venue-rating-updated-on').val().trim(),
            venueId: $(this).find('#venue-id').val().trim()
        };
        //var $distanceContainer = $(parentContainer).find('.venue-distance');
        var $yelpRatingContainer = $(parentContainer).find('.yelp-rating-stars')
        //cache venue-distance
        localforage.setItem(venueId+'distance', venueDistance);
        // //Get venue distance
        // if ($distanceContainer) {
        //     $($distanceContainer).getVenueDistance({
        //         venueName: venueParams.name,
        //         venueAddress : venueParams.location,
        //         userAddress: userAddress
        //     })
        // }

        //Get yelp ratings
        if ($yelpRatingContainer) {
            $($yelpRatingContainer).getYelpRatings({
                requestParams: venueParams
            })
        }
    });
 });

// to show/hide map button .. based on setting in admin feature ...
function mapfunctionalityCheck() {
    $.ajax({
        url: '/getMapFunctionalitystatus',
        method: 'GET',
        dataType: 'json',
        //data: {turnonmapfunctionality: turnonmapfunctionality },
        success: function (res) {
           if(res === true) {
                $('.onoffswitch-checkbox').prop('checked', true);
                if(document.getElementById("mapviewbtn")) {
                    document.getElementById("mapviewbtn").style.display = "block";
                }
            } else if(res === false) {
                $('.onoffswitch-checkbox').prop('checked', false);
                if(document.getElementById("mapviewbtn")) {
                    document.getElementById("mapviewbtn").style.display = "none";
                }
            }
        },
        error: function (err) {
            console.log('Error:',err);
        },
    });
}

function savemapfunctionalityvalue() {

    var getmapshowhideValue = document.getElementById('mapshowhidevalue').value;

    if(getmapshowhideValue == 'true') {
        var turnonmapfunctionality = false;
    }
    else if(getmapshowhideValue == 'false') {
        var turnonmapfunctionality = true;
    }
    $.ajax({
        url: '/savemapfunctionalitystatus',
        method: 'GET',
        dataType: 'json',
        data: {turnonmapfunctionality: turnonmapfunctionality },
        success: function (res) {
            if (res.status == 'Successful') {
                document.getElementById('mapshowhidevalue').value = turnonmapfunctionality;
                Swal.fire("Saved Successfully!");
            } else {
                Swal.fire("Oops", res.message, "error");
            }
        },
        error: function (err) {
            toastr.error("We couldn't connect to the server!");
        },
    });
}

function openSearchCategory(evt, cityName) {
    if(cityName == 'listview') {
    //if map clicked and hence new lat, lng, reload page
      if(doMapSearch && doMapSearch==true){
        //reload page only if map clicked
        let view = $(this).data('view');
        //reload current page
        $('form[action="/basicsearch/submit"]').submit();
      }
      if($(".mapviewbtn")) {
          $(".mapviewbtn").css("display","block") ;
      }
      if($(".listviewbtn")) {
          $(".listviewbtn").css("display","none") ;
      }
      if(document.getElementById("listview")) {
          document.getElementById("listview").style.display = "block";
      }
      if(document.getElementById("mapview")) {
          document.getElementById("mapview").style.display = "none";
      }
    }
    else if(cityName == 'mapview') {
       if($(".mapviewbtn")) {
          $(".mapviewbtn").css("display","none") ;
      }
      if($(".listviewbtn")) {
          $(".listviewbtn").css("display","block") ;
      }
      if(document.getElementById("listview")) {
          document.getElementById("listview").style.display = "none";
      }
      if(document.getElementById("mapview")) {
          document.getElementById("mapview").style.display = "block";
      }
        if(primaryType=="restaurant"){ //show restaurant map
          if( document.getElementById("map_canvas_restaurant")){
            document.getElementById("map_canvas_restaurant").style.display = "block";
          }
          if( document.getElementById("map_canvas_menuitem")){
            document.getElementById("map_canvas_menuitem").style.display = "none";
          }
        }
        else{
          if( document.getElementById("map_canvas_restaurant")){
            document.getElementById("map_canvas_restaurant").style.display = "none";
          }
          if( document.getElementById("map_canvas_menuitem")){
            document.getElementById("map_canvas_menuitem").style.display = "block";
          }
        }
    }
}

 var pagenumber=1;
 $('#loadmenuvenuitems').click(function (event) {
     pagenumber++;
     searchResults(primaryType,pagenumber);
 });
 var userid  = $('#userId').val();
  let wishlist = [];
  // return dislike records too
  if(userid){
    $.ajax({
      url: '/wishListController/getWishList',
      method: 'GET',
      dataType: 'json',
      success: function (result) {
        wishlist = result.data.wishlist;
      },
    });
  } 
$(document).on("click",".rate-item-home",function(e){
      const venueSlug1 = $(this).data('venueslug');
      const venueId = $(this).data('venueid');
      const menuItemId = $(this).data('menuitemid');
      localStorage.page_log = '';
      if(venueSlug1 && menuItemId){
          sessionStorage.setItem('rate_item_home',menuItemId);
          let url = `/restaurant/${venueSlug1}`;
          window.location.href = url;
      }
      else if(venueId && menuItemId){
          sessionStorage.setItem('rate_item_home',menuItemId);
          let url = `/restaurant/${venueId}`;
          window.location.href = url;
      }
  });
 function searchResults (type="restaurant",pagenumber){
      $(`#serach-loader`).css('display', 'none');
      $("#intro-container").css("display","none");
      var url = new URL(window.location.href);
      var filter_menu_type_prefs = url.searchParams.get("filter_menu_type_prefs");
     
      if(filter_menu_type_prefs){
         localStorage.setItem('filter_menu_type_prefs', JSON.stringify(filter_menu_type_prefs));
      }else{
          localStorage.removeItem('filter_menu_type_prefs');
      
      }
     

      if(type=='menuitem' && typeof(resultsMenu) != "undefined" &&  resultsMenu){
          $("#search_filter_price").css("display","block")
          $("#menuItemsDiv").css("display", "block");
          $("#venueItemsDiv").css("display", "none");
          let ItemValuediv = $('#search-menuItemsDiv');
          ItemValuediv.html('');
          if(resultsMenu.length==0){
            
            ItemValuediv.html(`Your search returned no menu items. `+locationError);
            $("#menuCountDivResults").html(0);
          } else {
            //show total count
            $("#menuCountDivResults").html(resultsMenu.length);
            let adminflavormaxValue=$("#flavorMatchPercentForColorGreen").val();
            let adminflavorminValue=$("#flavorMatchPercentForColorRed").val();
            for(var i=0;i<Math.min((pagenumber*51),resultsMenu.length);i++) {
               let venueDetailsForMenu = null;
               if(venuesDetails && venuesDetails.length>0) {
                  venueDetailsForMenu = venuesDetails.find(x=>x.venueId == resultsMenu[i].venueId);
               }
              else{
                continue;
              }
              let menuHtml = renderSearchMenuItem(resultsMenu[i], venueDetailsForMenu, searchStringMenuItem, adminflavormaxValue, adminflavorminValue, '', i);
              ItemValuediv.append(menuHtml);
            }; //end of for loop
            
            if(resultsMenu.length<=(51*pagenumber)  ){
              $("#loadmenuvenuitems").css("display","none");
            }
            else{
             $("#loadmenuvenuitems").css("display","block");
            }
            let displayedRecords = Math.min((pagenumber *  51),resultsMenu.length);
            ItemValuediv.append(`<span class="results-count col-md-12">Currently displaying ${displayedRecords} results</span>`);
            showImages();
          }
      }
      else if(type =='restaurant' && typeof(resultsVenues) != "undefined" && resultsVenues  ){
        $("#search_filter_price").css("display","none")
        $("#venueItemsDiv").css("display", "block");
        $("#menuItemsDiv").css("display", "none");
        let venuItemsIdDiv = $('#search-menuItemsDiv');
        venuItemsIdDiv.html('');
        if(resultsVenues.length==0){
          //venuItemsIdDiv.html(`Your search returned no restaurants. `+locationError);
          $("#venueCountDivResults").html(0);
        } else {
          let venueDiv = '';
          for(var j=0;j<Math.min((pagenumber*51),resultsVenues.length);j++) {
            let venueHtml = renderSearchVenue(resultsVenues[j], venuesDetails, j);
            venueDiv += venueHtml;
          }; //end for venues
          $('.go-to-specified-restaurant').on('click', function(event){
              event.preventDefault()
              window.stop()
              let link = $(this).find('a').attr('href')
              window.location.href = link
          })
          $("#venueCountDivResults").html("")
          $("#venueCountDivResults").html(resultsVenues.length)
          venuItemsIdDiv.append(venueDiv);
          //show total count
          $("#venueCountDivResults").val(resultsVenues.length);
          if(resultsVenues.length<=(51*pagenumber)  ){
            $("#loadmenuvenuitems").css("display","none");
          }
          else{
           $("#loadmenuvenuitems").css("display","block");
          }
          showImages(); //this is defined in basicsearch-home
          let displayedRecords = Math.min((pagenumber *  51),resultsVenues.length);
          venuItemsIdDiv.append(`Currently displaying ${displayedRecords} results`);
           $('.yelpresults-content').each(function(index, resultsVenues) {
              var parentContainer = ".yelpresults-container" + index;
              var venueParams = {
                  name: ($(this).find('#venue-name').text() || '').trim(),
                  location: ($(this).find('#venue-location').val() || '').trim(),
                  lat: ($(this).find('#venue-lat').val() || '').trim(),
                  lng: ($(this).find('#venue-lng').val() || '').trim(),
                  phone: ($(this).find('#venue-phone').val() || '').trim()
              };
              var $yelpRatingContainer = $(parentContainer).find('.yelp-rating-stars')

              //Get yelp ratings
              if ($yelpRatingContainer) {
                  $($yelpRatingContainer).getYelpRatings({
                      requestParams: venueParams
                  })
              }
              
          });
        }
      }
      else {
      //no results
          var venuItemsIdDiv = $('#search-menuItemsDiv');
          venuItemsIdDiv.html(`Your search returned no results. `+locationError);
          $("#menuCountDivResults").html(0);
          $("#venueCountDivResults").html(0);
      }
    }


